import { Environment } from '@src/config/environment';
import { type LoaderFunction, redirect } from 'react-router-dom';
import { Paths } from '@src/config/paths';
import { SearchParamKeys } from '@funnellab/shared/src/types/SearchParamKeys';
import authenticationService from '@src/api/services/AuthenticationService.ts';

export const registerLoader: LoaderFunction = async ({ request }) => {
  const requestUrl = new URL(request.url);

  const navigatingToVerify =
    requestUrl.pathname === Paths.REGISTER + Paths.VERIFY_MAIL;

  const isLoggedIn = await authenticationService.isLoggedIn();
  if (isLoggedIn) {
    const user = await authenticationService.getCurrentUser();
    if (user.isVerified) {
      return redirect(Paths.ROOT);
    } else if (!navigatingToVerify) {
      return redirect(Paths.REGISTER + Paths.VERIFY_MAIL);
    }
  } else if (navigatingToVerify) {
    return redirect(
      Paths.LOGIN +
        `?${SearchParamKeys.LOGIN_REDIRECT_URL}=${encodeURIComponent(requestUrl.toString().replace(Environment.APP_URL, ''))}`,
    );
  }
  return null;
};
